export default __webpack_public_path__ + "static/media/caloTokenIntro.8bc20c9f.png";